const ROLE_CLAIM_KEYS = [
  'role',
  'roles',
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
];

function normalizeRoleValue(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value
      .filter((item): item is string => typeof item === 'string')
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
  }

  if (typeof value === 'string') {
    return value
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item.length > 0);
  }

  return [];
}

function parseJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2) {
      return null;
    }

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const normalized = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const decoded = atob(normalized);

    // Decodifica payload UTF-8 para suportar caracteres especiais
    const json = decodeURIComponent(
      Array.from(decoded)
        .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join('')
    );

    const payload = JSON.parse(json);
    if (!payload || typeof payload !== 'object') {
      return null;
    }

    return payload as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function getTokenRoles(token: string): string[] {
  if (!token || token.trim() === '') {
    return [];
  }

  const payload = parseJwtPayload(token);
  if (!payload) {
    return [];
  }

  const roles = ROLE_CLAIM_KEYS
    .flatMap((claimKey) => normalizeRoleValue(payload[claimKey]))
    .map((role) => role.toLowerCase());

  return Array.from(new Set(roles));
}

export function tokenHasRole(token: string, roleName: string): boolean {
  const normalizedRole = roleName.trim().toLowerCase();
  if (!normalizedRole) {
    return false;
  }

  return getTokenRoles(token).includes(normalizedRole);
}
